import { render, staticRenderFns } from "./KDSItem.vue?vue&type=template&id=1a1b857e&scoped=true"
import script from "./KDSItem.vue?vue&type=script&lang=js"
export * from "./KDSItem.vue?vue&type=script&lang=js"
import style0 from "./KDSItem.vue?vue&type=style&index=0&id=1a1b857e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b857e",
  null
  
)

export default component.exports